import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

export const HeaderTextWrapper = styled.div`
    margin-top: 77px;
    width: 610px;
    gap: 4px;

    @media (max-width: ${breakPoints.desktop}) {
        margin-top: 117px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        margin-top: 77px;
        width: 485px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        margin-top: 58vw;
    }

    @media (max-width: ${breakPoints.mobile}) {
        margin-top: 60vw;
        width: auto;
    }

    @media (max-width: 375px) {
        margin-top: 90vw;
    }
`;

export const H1 = styled.h1`
    margin: 0;
`;

export const HeaderSubtext = styled.div`
    ${FONTS.L};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.M};
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.L};
    }

    @media (max-width: ${breakPoints.sMobile}) {
        ${FONTS.S};
    }
`;


export const LogoYandexStation = styled.img`
    width: 180px;
    height: 32px;

    @media (max-width: ${breakPoints.desktop}) {
        width: 130px;
        height: 23px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 195px;
        height: 33px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: 100px;
        height: 18px;
    }
`;
